// Utility to determine the correct rate for a product order
export function setRate(
  { AACost, USDRetail, KRWRetail },
  currency,
  company,
  billingCountry
) {
  if (company && company.trim() === 'Aurender America Inc.') {
    // AA로 로그인한 경우
    if (
      billingCountry &&
      billingCountry.trim().includes('United States') &&
      AACost
    ) {
      // Billing Country가 United States인 경우
      return AACost;
    } else {
      // Billing Country가 United States가 아닌 경우
      return USDRetail;
    }
  }
  if (currency && currency.trim() === 'USD') {
    return USDRetail;
  } else if (currency && currency.trim() === 'KRW') {
    return KRWRetail;
  }
  return USDRetail;
}
